module.exports = __webpack_public_path__ + "img/fourday1-2.724d14e9.jpg";